import { IPage, ISearchPage } from '@/types/AppTypes'
import { httpRequest } from '@/utils/HttpRequest'



//维修物资
export interface IArchivesAssetsDetail {
    temporaryId?: number
    id: string
    brandCode?: string
    brandName?: string
    brandNameEn?: string
    code?: string
    createTime?: string
    createUser?: string
    deleteFlag?: string
    assetsAmount?: number
    assetsCode?: string
    assetsId?: string
    assetsName?: string
    assetsNum?: number
    assetsPrice?: number
    orderNum?: string
    remark?: string
    traceId?: string
    typeCode?: string
    typeName?: string
    updateTime?: string
    updateUser?: string
    isChoosed?: boolean
}
export interface IAssetsDetail {
    branch?: string
    branchList?: string
    brandCode?: string
    brandName?: string
    brandNameEn?: string
    code?: string
    enable?: string
    factoryCode?: string
    key?: string
    limitLower?: string
    limitUpper?: string
    madeFrom?: string
    minOrderNum?: string
    model?: string
    name?: string
    nameEn?: string
    note?: string
    purchasePrice?: number
    replaceCode?: string
    retailPrice?: string
    status?: string
    typeCode?: string
    typeName?: string
    typeNameEn?: string
    unitCode?: string
    unitName?: string
    unitNameEn?: string
    ver?: string
    wholesalePrice?: string
}

export interface IAssetsDetailSearchFields extends ISearchPage {
    code?: string
    name?: string
}

//详情
export interface IUserControlDetail {
    id: string
    code: string
    name: string
    intervalMileage?: string
    warningMileage?: string
    vehicleBrandCode?: string
    vehicleBrandName?: string
    vehicleModelCode?: string
    vehicleModelName?: string
    assetsAmount?: number
    itemAmount?: number
    disableFlag?: string
    remark?: string
    createTime?: string
    createUser?: string
    archivesAssets?: IArchivesAssetsDetail[]
    [key: string]: any
}

//搜索条件
export interface IUserControlSearchFields {
    code?: string
    name?: string
    vehicleBrandCode?: string
    vehicleModelCode?: string
}

export interface IUserControlSearch extends IUserControlSearchFields, ISearchPage {
    shopId?: string
    shopCode?: string
    [key: string]: any
}

export interface IpositionSearch extends IUserControlSearchFields, ISearchPage {}

//新增
export interface IUserControlInsert extends IUserControlDetail {}

//编辑
export interface IUserControlUpdate extends IUserControlInsert {
    id: string
}

class UserControlService {
    async orgPage(searchVo: IUserControlSearch) {
        // const apiUrl = '/portal/auth/user/findUserDetail'
        const apiUrl = '/portal/auth/user/findUser'
        return await httpRequest.post<IPage<IUserControlDetail>>(apiUrl, searchVo)
    }
    async page(searchVo: IUserControlSearch) {
        const apiUrl = '/portal/auth/user/findUserDetail'
        // const apiUrl = '/portal/auth/user/findUser'
        return await httpRequest.post<IPage<IUserControlDetail>>(apiUrl, searchVo)
    }
    async one(id: string) {
        const apiUrl = `/tco/archives/select/${id}`
        return await httpRequest.get<IUserControlDetail>(apiUrl)
    }
    async insert(insertVo: IUserControlInsert) {
        const apiUrl = '/tco/archives/insert'
        return await httpRequest.post<boolean>(apiUrl, insertVo)
    }
    async update(updateVo: IUserControlUpdate) {
        const apiUrl = '/tco/archives/update'
        return await httpRequest.post<boolean>(apiUrl, updateVo)
    }
}

class MateriaService {
    async page(searchVo: IAssetsDetailSearchFields, config: object = {}) {
        const apiUrl = '/tco/assets/page'
        return await httpRequest.post<IPage<IAssetsDetail>>(apiUrl, searchVo, config)
    }
}
export const userControlService = new UserControlService()
export const materiaService = new MateriaService()
